export default __webpack_public_path__ + "static/media/character login.3278f884.png";